export const AUCTION_HOUSE_ADDRESS =
  "H417SNobqf9GChHiGsLqwTKfcYpTpLHLrEehMQr7dkXf";

// export const SOLANA_RPC_NODE = "https://dry-omniscient-sound.solana-devnet.quiknode.pro/0c43b7ede7c26124b53db25cc65c1f018abd195e/";
export const SOLANA_RPC_NODE = "https://api.devnet.solana.com"
export const SOLSCANCLUSTER = SOLANA_RPC_NODE;
export const SOLSCANURL = "https://api.solscan.io";

// "mainnet-beta", "testnet", "devnet",
export const THIRDWEB_DESIRED_NODE = "devnet";

export const ADMIN_ADDRESSESS = [
  "tHrHUwvMQPTDJaZRffpfFUrAb7rQPKS6ZixKFMh4dDf",
  "CTzfpz3QQ5MUYnGeunfChs5gHzzzThV8JQS44NzJPKrj",
  "FPJQvNhAJtU1SQj6t2qPvgcF15SpxGzBTSh6J4HBKmQD",
  "3SX6hVQi1MFqJnq79kKqaifHEsBBS9JQes56MchtMUDf",
  "DiNWBizaMad8Maqrg5nfRMp6QYAuvqyrs59mtPPpVNZX",
  "FaHeLiQJYMuyn3sEVykiVitMEoVTMVVFdoAWMKm2DtgP",
];

export const OWNER_ADDRESS = "3SX6hVQi1MFqJnq79kKqaifHEsBBS9JQes56MchtMUDf";
